var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/register/steps/RegisterMinorPersonalInfo.tsx";
import React, { useCallback } from 'react';
import { Text as TextParallax } from '@adc/parallax-component-library';
import { LocalDate } from '@js-joda/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Footer, Form, Header, LogoActionBar, Main, ScrollContainer } from 'Components/utility';
import { Input } from 'Components/utility/Input';
import { formatLocalDate } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
const RegisterMinorPersonalInfo = ({
  next,
  back,
  validateNameLength,
  values: currentValues
}) => {
  const validationSchema = Yup.object().shape({
    guardianFirstName: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.helpText.required')).trim(),
    guardianLastName: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.helpText.required')).trim()
  });
  const onSubmit = useCallback(async values => {
    try {
      if (!values.guardianFirstName || !values.guardianLastName) {
        return;
      }
      const isValid = validateNameLength(values.guardianFirstName, values.guardianLastName);
      if (!isValid) {
        return;
      }
      const register = {
        ...currentValues,
        ...values
      };
      next(register);
    } catch (err) {
      log.error(err);
    }
  }, [currentValues, next, validateNameLength]);
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    isValid,
    errors,
    touched,
    values
  } = useFormik({
    initialValues: {
      ...currentValues
    },
    validationSchema: validationSchema,
    onSubmit,
    validateOnBlur: true
  });
  const handleOnBack = useCallback(() => {
    back(values);
  }, [back, values]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    actionButtonTestID: "RegisterMinorPersonalInfo.action-go-back",
    titleTestID: "RegisterMinorPersonalInfo.actionTitle",
    title: i18n.t('CreateAccountPersonalInfo.title'),
    onBack: handleOnBack,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    titleTestID: "RegisterMinorPersonalInfo.title",
    subtitleTestID: "RegisterMinorPersonalInfo.subtitle",
    title: i18n.t('CreateAccountPersonalInfo.title'),
    subtitle: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.primaryText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.placeholder'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.label'),
    testID: "guardianFirstName",
    inputMode: "text",
    errorMessage: errors.guardianFirstName,
    isInvalid: errors.guardianFirstName && touched.guardianFirstName ? true : false,
    value: values.guardianFirstName,
    onChangeText: handleChange('guardianFirstName'),
    onBlur: handleBlur('guardianFirstName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.placeholder'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.label'),
    testID: "guardianLastName",
    inputMode: "text",
    errorMessage: errors.guardianLastName,
    isInvalid: errors.guardianLastName && touched.guardianLastName ? true : false,
    value: values.guardianLastName,
    onChangeText: handleChange('guardianLastName'),
    onBlur: handleBlur('guardianLastName'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(TextParallax, {
    nativeID: "CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.secondaryText",
    fontWeight: "$bodySmall.strong",
    fontSize: "$bodySmall.strong",
    color: "$text.100",
    textTransform: "uppercase",
    marginTop: "$4",
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 11
    }
  }, i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.secondaryText')), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.label'),
    testID: "firstName",
    inputMode: "text",
    value: values.firstName,
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.label'),
    testID: "lastName",
    inputMode: "text",
    value: values.lastName,
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 160,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.dob.label'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.dob.label'),
    testID: "dateOfBirth",
    inputMode: "text",
    value: values.dateOfBirth ? formatLocalDate(LocalDate.parse(values.dateOfBirth), i18n.language) : '',
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 172,
      columnNumber: 11
    }
  }), currentValues.country === 'FR' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
    testID: "gender",
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.placeholder'),
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.label'),
    value: values.gender ? values.gender === 'undetermined' ? i18n.t('Global.microcopy.genderOptions.other') : i18n.t(`Global.microcopy.genderOptions.${values.gender}`) : '',
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 190,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(Input, {
    testID: "birthCountry",
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.placeholder'),
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.label'),
    value: values.birthCountry ? i18n.t(`Global.microcopy.countries.${values.birthCountry.toUpperCase()}`) : '',
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 210,
      columnNumber: 15
    }
  }), values.birthCountry === 'FR' && /*#__PURE__*/React.createElement(Input, {
    "aria-label": i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.label'),
    placeholder: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.placeholder'),
    label: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.label'),
    testID: "birthZipCode",
    value: values.birthZipCode,
    onChangeText: handleChange('birthZipCode'),
    onBlur: handleBlur('birthZipCode'),
    disabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 17
    }
  })))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.links.next.label'),
    onButtonSubmit: handleSubmit,
    buttonTestID: "CreateAccountPersonalInfo.next-btn",
    isButtonDisabled: !values.guardianFirstName || !values.guardianLastName || !isValid,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 252,
      columnNumber: 7
    }
  }));
};
export default RegisterMinorPersonalInfo;